import { Link, useLocation } from 'react-router-dom';

/**
 * HomeLink — `<Link>` that smooth-scrolls to the top when the user clicks it
 * while already on the destination route.
 *
 * Cross-route navigation is left to the global `<ScrollToTop>` component
 * (which performs an instant jump after the pathname changes). Scheduling
 * the scroll in `requestAnimationFrame` ensures it runs after React has
 * committed any layout side-effects of the click.
 */
export const HomeLink = ({ to, onClick, children, ...rest }) => {
    const { pathname } = useLocation();

    const handleClick = (event) => {
        if (onClick) onClick(event);
        if (pathname === to) {
            requestAnimationFrame(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        }
    };

    return (
        <Link to={to} onClick={handleClick} {...rest}>
            {children}
        </Link>
    );
};
